import type { Lottery } from '@lotta/shared/types-lottery-schemas';

/**
 * Any lottery were we collect the sign up data
 *
 * Eg swipe and simple signup, but not purchase based lotteries.
 */
export const isSignupBasedLottery = (lottery: Lottery) => {
  // For now, anything not purchase based is signup based
  return lottery.modules.some((module) => ['simple-signup', 'swipe'].includes(module));
};
